/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  /*!********************************!*\
    !*** ./resources/js/custom.js ***!
    \********************************/
  /******/
  (function () {
    // webpackBootstrap
    var __webpack_exports__ = {};
    /*!********************************!*\
      !*** ./resources/js/custom.js ***!
      \********************************/
  
    var buttonMenu = document.getElementById("buttonMenu");
    var moblileMenu = document.getElementById("moblileMenu");
    buttonMenu.addEventListener("click", function () {
      buttonMenu.classList.toggle("bg-gray-100");
      moblileMenu.classList.toggle("-translate-x-full"); //   moblileMenu.classList.remove("hidden");
      //   moblileMenu.classList.remove("hidden");
    });
    var acc = document.getElementsByClassName("accordion");
    var i;
  
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.lastElementChild.classList.toggle("transform");
        var panel = this.nextElementSibling;
  
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  
    var accmenu = document.getElementsByClassName("accordionMenu");
    var i;
  
    for (i = 0; i < accmenu.length; i++) {
      accmenu[i].addEventListener("click", function () {
        this.firstElementChild.lastElementChild.classList.toggle("transform");
        var panel = this.lastElementChild;
        panel.classList.toggle("hidden");
      });
    }
  
    var dropmenu = document.getElementsByClassName("dropmenu");
    var i;
  
    for (i = 0; i < dropmenu.length; i++) {
      dropmenu[i].addEventListener("mouseover", function () {
        this.firstElementChild.lastElementChild.classList.toggle("transform");
  
        function addClassMenu() {
          panel.classList.add("opacity-100");
        }
  
        var panel = this.lastElementChild;
        panel.classList.toggle("hidden");
        setTimeout(addClassMenu, 0);
      });
      dropmenu[i].addEventListener("mouseout", function () {
        this.firstElementChild.lastElementChild.classList.toggle("transform");
  
        function rmClassMenu() {
          panel.classList.remove("opacity-100");
        }
  
        var panel = this.lastElementChild;
        panel.classList.toggle("hidden");
        setTimeout(rmClassMenu, 0);
      });
    }
  
    var dropmenuMobile = document.getElementsByClassName("dropmenumobile");
    var i;
  
    for (i = 0; i < dropmenuMobile.length; i++) {
      dropmenuMobile[i].addEventListener("click", function () {
        this.firstElementChild.lastElementChild.classList.toggle("transform");
        var panel = this.lastElementChild;
  
        function toggleClassMenu() {
          panel.classList.toggle("opacity-100");
        }
  
        panel.classList.toggle("hidden");
        setTimeout(toggleClassMenu, 10);
      });
    }
  
    window.addEventListener('scroll', function () {
      if (pageYOffset >= '200') {
        addClassUp();
      }
  
      if (pageYOffset <= '200') {
        rmClassUp();
      }
    });
    var butUp = document.getElementById("buttonUp");
    butUp.addEventListener('click', function () {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  
    function addClassUp() {
      var buttonUp = document.getElementById("buttonUp");
      buttonUp.classList.add('flex');
      buttonUp.classList.remove('hidden');
    }
  
    function rmClassUp() {
      var buttonUp = document.getElementById("buttonUp");
      buttonUp.classList.remove('flex');
      buttonUp.classList.add('hidden');
    }
    /******/
  
  })();
  /******/ })()
  ;